import { useGetters } from "vuex-composition-helpers"
import UserMenu from "@/components/UserMenu";

export default {
  name: "SplashContainer",
  components: {
    UserMenu,
  },
  setup() {
    const {
      currentUser,
    } = useGetters(["currentUser"]);

    return {
      currentUser,
    }
  },
};
